
import { defineComponent, computed, PropType } from 'vue'

// maps to status styles
export enum StatusType {
  Draft = 'draft',
  Default = 'default',
  Neutral = 'neutral',
  Highlight = 'highlight',
  Minimal = 'minimal',
  Success = 'success',
  Warn = 'warn',
  Danger = 'danger',
  Error = 'error',
  Disabled = 'disabled'
}

interface StatusTypeMap {
  [key: string]: StatusType
}

// straight up dawg
const DEFAULT_STATUS_MAP:StatusTypeMap = Object.fromEntries(Object.keys(StatusType).map(k => ([StatusType[k], StatusType[k]])))

enum StatusDisplay {
  Absolute = 'absolute',
  Inline = 'inline'
}

enum StatusPosition {
  TopRight = 'top-right',
  BottomRight = 'bottom-right',
  BottomLeft = 'bottom-left',
  TopLeft = 'top-left',
  Center = 'center'
}

const MAX_LABEL_LENGTH = 150

export default defineComponent({
  name: 'StatusIndicator',
  props: {
    display: {
      type: String as PropType<StatusDisplay>,
      default: StatusDisplay.Absolute
    },
    position: {
      type: String as PropType<StatusPosition>,
      default: StatusPosition.TopRight
    },
    label: {
      type: String
    },
    tooltip: {
      type: [String, Boolean]
    },
    typeMap: {
      type: Object as PropType<StatusTypeMap>,
      default: DEFAULT_STATUS_MAP
    },
    type: {
      type: String as PropType<StatusType>,
      default: StatusType.Default
    }
  },
  setup (props) {
    return {
      parsedLabel: computed(() => {
        return `${(props.label || '').substring(0, MAX_LABEL_LENGTH)}${(props.label || '').length > MAX_LABEL_LENGTH ? '...' : ''}`
      }),
      parsedTooltip: computed(() => {
        return typeof props.tooltip === 'boolean' ? false : `${(props.tooltip || props.type).substring(0, MAX_LABEL_LENGTH)}${(props.tooltip || props.type).length > MAX_LABEL_LENGTH ? '...' : ''}`
      })
    }
  }
})
